export default "__VITE_ASSET__DOQgSQsf__"